import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const SwapIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.4 11H15c.6 0 1 .4 1 1s-.4 1-1 1H3.4l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-3-3c-.4-.4-.4-1 0-1.4l3-3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L3.4 11Zm9.2-6H1c-.6 0-1-.4-1-1s.4-1 1-1h11.6l-1.3-1.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l3 3c.4.4.4 1 0 1.4l-3 3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L12.6 5Z", fill: "currentColor" })));
});
SwapIcon.displayName = 'SwapIcon';
export default SwapIcon;
